import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import AdmissionRequestService from "../../../api/AdmissionRequestService";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import moment from "moment";
import { Knob } from "primereact/knob";
import useAuth from "../../../hooks/useAuth";
import PreselectionService from "../../../api/PreselectionService";
import ChallengeService from "../../../api/ChallengeService";
import InterviewService from "../../../api/InterviewService";
import { Toast } from "primereact/toast";

const SingleCandidate = () => {
  const { auth } = useAuth();
  const [admissionRequest, setAdmissionRequest] = useState();
  const [testSubmission, setTestSubmission] = useState();
  const [requirementSubmission, setRequirementSubmission] = useState();
  const [selections, setSelections] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [openPreselectionModal, setOpenPreselectionModal] = useState(false);
  const [openInterviewModal, setOpenInterviewModal] = useState(false);
  const [openChallengeModal, setOpenChallengeModal] = useState(false);
  const { id } = useParams();
  const [observation, setObservation] = useState("");
  const [note, setNote] = useState("");
  const [motivationObservation, setMotivationObservation] = useState("");
  const [motivation, setMotivation] = useState("");
  const [logicObservation, setLogicObservation] = useState("");
  const [logic, setLogic] = useState("");
  const [availabilityObservation, setAvailabilityObservation] = useState("");
  const [availability, setAvailability] = useState("");
  const [preRequirementObservation, setPreRequirementObservation] =
    useState("");
  const [preRequirement, setPreRequirement] = useState("");
  const [vulnerabilityObservation, setVulnerabilityObservation] = useState("");
  const [vulnerability, setVulnerability] = useState("");
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const toast = useRef(null);

  const juryPermissions = [
    "traiter_candidature",
    "donner_une_appreciation",
  ];
  useEffect(() => {
    AdmissionRequestService.get(id)
      .then((res) => {
        setAdmissionRequest(res.data.admissionRequest);
        setTestSubmission(res.data.testSubmission);
        setRequirementSubmission(res.data.requirementSubmission);
        setInterviews(res.data.interviews);
        setChallenges(res.data.admissionChallenges);
        setSelections(res.data.preselections);
      })
      .catch((err) => console.log("err", err));
  }, [id, refresh]);

  const submitInterview = (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      !motivation ||
      !motivationObservation ||
      !availability ||
      !availabilityObservation ||
      !logic ||
      !logicObservation ||
      !preRequirement ||
      !preRequirementObservation ||
      !vulnerability ||
      !vulnerabilityObservation ||
      !observation
    ) {
      alert("Veuillez remplir tous les champs svp!");
      setLoading(false);
    } else {
      const data = {
        motivation: motivation,
        motivationObservation: motivationObservation,
        availability: availability,
        availabilityObservation: availabilityObservation,
        logic: logic,
        logicObservation: logicObservation,
        preRequirement: preRequirement,
        preRequirementObservation: preRequirementObservation,
        vulnerability: vulnerability,
        vulnerabilityObservation: vulnerabilityObservation,
        admission_request_id: id,
        observation: observation,
      };
      InterviewService.create(data)
        .then((res) => {
          setLoading(false);
          setRefresh(!refresh);
          setOpenInterviewModal(false);
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail:
              "Entretien effectuée avec succès. Passez à l'étape suivante",
            life: 4000,
          });
        })
        .catch((err) => {
          setLoading(false);
          console.log("err", err);
          toast.current.show({
            severity: "danger",
            summary: "Erreur",
            detail: "Impossible de traiter cette candidature",
            life: 4000,
          });
        });
    }
  };

  const submitChallenge = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!note || !observation) {
      alert("Veuillez remplir tous les champs svp!");
      setLoading(false);
    } else {
      const data = {
        admission_request_id: id,
        note: note,
        observation: observation,
      };
      ChallengeService.create(data)
        .then((res) => {
          setLoading(false);
          setRefresh(!refresh);
          setOpenChallengeModal(false);
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail: "Prairie traitée avec succès. Merci !",
            life: 4000,
          });
        })
        .catch((err) => {
          setLoading(false);
          toast.current.show({
            severity: "danger",
            summary: "Erreur",
            detail: "Impossible de traiter cette candidature",
            life: 4000,
          });
          console.log("err", err);
        });
    }
  };

  const submitPreselection = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!note || !observation) {
      alert("Veuillez remplir tous les champs svp!");
      setLoading(false);
    } else {
      const data = {
        admission_request_id: id,
        note: note,
        observation: observation,
      };
      PreselectionService.create(data)
        .then((res) => {
          setLoading(false);
          setRefresh(!refresh);
          setOpenPreselectionModal(false);
          toast.current.show({
            severity: "success",
            summary: "Erreur",
            detail:
              "Preselection traitée avec succès. Passez à l'étape suivante",
            life: 4000,
          });
        })
        .catch((err) => {
          toast.current.show({
            severity: "danger",
            summary: "Succès",
            detail: "Impossible de traiter cette candidature",
            life: 4000,
          });
          setLoading(false);
          console.log("err", err);
        });
    }
  };

  return (
    <div className="bg-white p-4 w-full border-round">
      <Toast ref={toast} />

      <Dialog
        header="Rapport Preselection"
        visible={openPreselectionModal}
        onHide={() => setOpenPreselectionModal(false)}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        <form onSubmit={submitPreselection} className="w-full">
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="note" className="font-bold block mb-3">
              Note
            </label>
            <InputNumber
              inputId="note"
              value={note}
              min={0}
              max={20}
              onValueChange={(e) => setNote(e.value)}
              suffix=" /20"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation
            </label>
            <InputTextarea
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto w-full"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px 0",
            }}
          >
            <Button
              label="Enregistrer"
              type="submit"
              icon="pi pi-check"
              loading={loading}
            />
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Rapport Entretien"
        visible={openInterviewModal}
        onHide={() => setOpenInterviewModal(false)}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        <form onSubmit={submitInterview} className="w-full">
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="motivation" className="font-bold block mb-3">
              Degré de motivation
            </label>
            <InputNumber
              inputId="motivation"
              value={motivation}
              min={0}
              max={5}
              onValueChange={(e) => setMotivation(e.value)}
              suffix=" /5"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation sur la motivation
            </label>
            <InputTextarea
              value={motivationObservation}
              onChange={(e) => setMotivationObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="availability" className="font-bold block mb-3">
              Disponibilité
            </label>
            <InputNumber
              inputId="availability"
              value={availability}
              min={0}
              max={5}
              onValueChange={(e) => setAvailability(e.value)}
              suffix=" /5"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation sur la disponibilité
            </label>
            <InputTextarea
              value={availabilityObservation}
              onChange={(e) => setAvailabilityObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="logic" className="font-bold block mb-3">
              Concordance entre le projet professionnel et la formation
            </label>
            <InputNumber
              inputId="logic"
              value={logic}
              min={0}
              max={3}
              onValueChange={(e) => setLogic(e.value)}
              suffix=" /3"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation sur la concordance
            </label>
            <InputTextarea
              value={logicObservation}
              onChange={(e) => setLogicObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="pre" className="font-bold block mb-3">
              Prérequis
            </label>
            <InputNumber
              inputId="pre"
              value={preRequirement}
              min={0}
              max={2}
              onValueChange={(e) => setPreRequirement(e.value)}
              suffix=" /2"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation sur les prérequis
            </label>
            <InputTextarea
              value={preRequirementObservation}
              onChange={(e) => setPreRequirementObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="vul" className="font-bold block mb-3">
              Niveau de vulnérabilité
            </label>
            <InputNumber
              inputId="vul"
              value={vulnerability}
              min={0}
              max={5}
              onValueChange={(e) => setVulnerability(e.value)}
              suffix=" /5"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation sur le niveau de vulnérabilité
            </label>
            <InputTextarea
              value={vulnerabilityObservation}
              onChange={(e) => setVulnerabilityObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full my-3">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation Générale
            </label>
            <InputTextarea
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto w-full"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px 0",
            }}
          >
            <Button
              label="Enregistrer"
              type="submit"
              icon="pi pi-check"
              loading={loading}
            />
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Rapport Prairie"
        visible={openChallengeModal}
        onHide={() => setOpenChallengeModal(false)}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        <form onSubmit={submitChallenge} className="w-full">
          <div
            className="flex-auto  w-full"
            style={{
              margin: "20px 0",
            }}
          >
            <label htmlFor="note" className="font-bold block mb-3">
              Note
            </label>
            <InputNumber
              inputId="note"
              value={note}
              min={0}
              max={20}
              onValueChange={(e) => setNote(e.value)}
              suffix=" /20"
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex-auto w-full">
            <label htmlFor="obsv" className="font-bold block mb-2">
              Observation
            </label>
            <InputTextarea
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="flex-auto w-full"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px 0",
            }}
          >
            <Button
              label="Enregistrer"
              type="submit"
              icon="pi pi-check"
              loading={loading}
            />
          </div>
        </form>
      </Dialog>
      <div className="">
        {auth?.permissions?.find((permission) =>
          juryPermissions.includes(permission?.name)
        ) && (
          <div className="flex justify-content-end w-full gap-4 py-1">
            {admissionRequest?.level == 0 &&
            selections.filter((int) => int.user_id == auth?.user?.id).length ==
              0 &&
            !auth?.roles.includes("candidate") ? (
              <Button
                label="Preselection"
                onClick={() => setOpenPreselectionModal(true)}
              />
            ) : admissionRequest?.level == 1 &&
              interviews.filter((int) => int.user_id == auth?.user?.id)
                .length == 0 &&
              !auth?.roles.includes("candidate") ? (
              <Button
                label="Entretien"
                onClick={() => setOpenInterviewModal(true)}
              />
            ) : admissionRequest?.level != 0 &&
              admissionRequest?.level != 1 &&
              challenges.filter((int) => int.user_id == auth?.user?.id)
                .length == 0 &&
              !auth?.roles.includes("candidate") ? (
              <Button
                label="Prairie"
                onClick={() => setOpenChallengeModal(true)}
              />
            ) : (
              ""
            )}
          </div>
        )}
        <Panel className="my-3" header="Informations Personnelles">
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Matricule :</span>
            <span> {admissionRequest?.user?.identifier}</span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Nom complet :</span>
            <span>
              {" "}
              {admissionRequest?.user?.firstname +
                " " +
                admissionRequest?.user?.lastname}
            </span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Email :</span>
            <span> {admissionRequest?.user?.email}</span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Date de naissance :</span>
            <span> {admissionRequest?.user?.birthday}</span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Age :</span>
            <span>
              {" "}
              {moment().diff(admissionRequest?.user?.birthday, "years") +
                " ans"}
            </span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Sexe :</span>
            <span>
              {" "}
              {admissionRequest?.user?.gender == 0
                ? "Masculin"
                : admissionRequest?.user?.gender == 1
                ? "Féminin"
                : "Autre"}
            </span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Téléphone :</span>
            <span> {admissionRequest?.user?.phone}</span>
          </div>

          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Profession :</span>
            <span> {admissionRequest?.user?.profession}</span>
          </div>

          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Nationnalité :</span>
            <span> {admissionRequest?.user?.nationality}</span>
          </div>

          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Niveau d'étude :</span>
            <span> {admissionRequest?.user?.level}</span>
          </div>
          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">
              Dernier diplôme obtenu :
            </span>
            <span> {admissionRequest?.user?.level}</span>
          </div>

          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">Adresse :</span>
            <span> {admissionRequest?.user?.address}</span>
          </div>

          <div className="flex justify-content-start mb-3 gap-5 align-items-center">
            <span className="font-bold block mr-2">
              Situation matrimoniale :
            </span>
            <span> {admissionRequest?.user?.matrimonial_situation}</span>
          </div>
        </Panel>
        <Panel className="my-3" header="Résultat des tests">
          <div className="card flex justify-content-center gap-5">
            <div className="card flex-column justify-content-center">
              <Knob
                value={parseFloat(requirementSubmission?.score) * 100}
                readOnly
                rangeColor="#754E47"
                valueColor="#4B9209"
              />
              <label htmlFor="preRe">Test de prérequis</label>
            </div>{" "}
            <div className="card flex-column justify-content-center">
              <Knob
                value={parseFloat(testSubmission?.score) * 100}
                readOnly
                rangeColor="#754E47"
                //valueColor="#4B9209"
              />
              <label htmlFor="preRe" className="font-bold text-black">
                Test de developpement personnel
              </label>
            </div>{" "}
          </div>
        </Panel>
      </div>
    </div>
  );
};

export default SingleCandidate;
